module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/bench/wood.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/bench/wood.jpg
// module id = 516
// module chunks = 0